export default {
    name: 'NykAlert',
    props: {
        type: {
            type: String,
            required: true,
        },
        role: {
            type: String,
            default: 'status'
        },
        ariaLive: {
            type: String,
            default: 'polite'
        },
        ariaAtomic: {
            type: String,
            default: 'true'
        }
    }
}
